import NotificationPreferencesCard from './NotificationPreferencesCard';
import NotificationSetupCard from './NotificationSetupCard';

/** Settings → Notifications: what dings you, and getting dings working on each device. */
export default function NotificationsPanel() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-5)' }}>
      <NotificationPreferencesCard />
      <NotificationSetupCard />
    </div>
  );
}
